import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import CloseIcon from '@mui/icons-material/Close'
import { Alert, IconButton } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import FadeAnimationDiv from 'components/common/Animations'
import { useTheme } from 'themes'

import { newFormThemeOverrides } from '../../styles'
import { infoImg } from '../../utils'

export const AlertInfoText = ({ infoAlertText }: { infoAlertText: string | ReactElement }) => {
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })
    const { t } = useTranslation()
    const [open, setOpen] = useState(true)

    return (
        <FadeAnimationDiv>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={formTheme}>
                    <Collapse in={open}>
                        <Alert
                            icon={false}
                            className="info"
                            action={
                                <IconButton
                                    className="alertDismiss"
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpen(false)
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            <div className="iconBox">
                                <img className="iconImg" src={infoImg} alt={t('Alert.Info')} />
                            </div>
                            <div className="message">
                                <span className="textWrap">
                                    <span className="type">{t('Alert.Info')}:</span>
                                    <span className="text">{infoAlertText}</span>
                                </span>
                            </div>
                        </Alert>
                    </Collapse>
                </ThemeProvider>
            </StyledEngineProvider>
        </FadeAnimationDiv>
    )
}

export default AlertInfoText
